import { VwpSupplier } from "@components/WeddingSupplierPackages/types"
import { callApi } from "./index"

export const getVwpSupplier = (supplierId: number): Promise<VwpSupplier> => {
  return callApi(`/packages/supplier/${supplierId}/`)
}
